import { FC, ReactNode } from 'react';

import { css } from '@emotion/react';
import { ToucanColors, ToucanComponents } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';

import { Box, BoxProps } from '~/components/shared/Box';

import { BorderedArea } from './BorderedArea';

const { Typography, Tooltip, ToucanIcon, useColorScheme } = ToucanComponents;

interface SectionProps extends BoxProps {
  title: string;
  tooltip?: string;
  alert?: ReactNode;
  className?: string;
}

const Section: FC<SectionProps> = ({ title, tooltip, children, alert, className, ...boxProps }) => {
  const theme = useTheme();
  const { uiSecondary } = useColorScheme();

  return (
    <Box className={className} {...boxProps}>
      <Typography
        variant="md"
        font="secondary"
        color={ToucanColors.gray[600]}
        css={css`
          margin-bottom: ${theme.spacing(2)};
        `}
      >
        {title}
        {tooltip && (
          <Tooltip title={tooltip} placement="top" width={300}>
            <ToucanIcon
              icon="info-circle"
              css={css`
                color: ${uiSecondary};
                width: 16px;
                margin-left: ${theme.spacing(1)};
              `}
            />
          </Tooltip>
        )}
      </Typography>
      <Box>{alert}</Box>
      <BorderedArea>{children}</BorderedArea>
    </Box>
  );
};

export default Section;
